<template>
  <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
       aria-hidden="true">
    <div class="modal-dialog  modal-dialog-centered" :class="size ? 'modal-' + size : ''" role="document">
      <div class="modal-content">
        <div v-if="hasHeaderSlot" class="modal-header">
          <slot name="header"></slot>
        </div>
        <div v-if="hasBodySlot" class="modal-body">
          <slot name="body"></slot>
        </div>
        <div v-if="hasFooterSlot" class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  name: "Modal",
  props: ['modalId', 'size'],
  data() {
    return {
      parameters: null
    }
  },
  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
    hasHeaderSlot() {
      return !!this.$slots.header;
    },
    hasBodySlot() {
      return !!this.$slots.body;
    }
  },
  methods: {
    modalOpened() {
      this.$emit('opened', this.parameters)
    },
    modalClosed() {
      this.$emit('closed')
    }
  },
  mounted() {
    window.$("#" + this.modalId).on("shown.bs.modal", (e) => {
      const parameters = window.$("#" + this.modalId).data('parameters');
      console.log("parameters2",parameters)
      this.parameters = parameters;
      this.modalOpened();
    })

    window.$("#" + this.modalId).on("hidden.bs.modal", (e) => {
      this.parameters = null;
      this.modalClosed();
    })
  }
}
</script>
<style>


</style>
<style lang="scss" scoped>
@import "../../assets/scss/MotivateColors";

.modal-xl {
  max-width: 80%;
}
.modal-content {
  padding: 24px 32px;
  background: $walterWhite;
  padding: 24px 32px;
  border-radius: 8px;
}


.modal-header {
  border-bottom: 2px solid $cadetGrey;
  padding: 0px 0px 10px 0px;
  font-size: 24px;
}

.modal-body {
  padding: 10px 0px;
  font-size: 21px;
}

.modal-footer {
  padding: 10px 0px;
  border-top: unset;
  font-size: 21px;
}

.modal-close-button {
  color: $besWelBlack;
  font-size: 24px;
}

</style>